/*=========================================================================================
  File Name: moduleEcommerceState.js
  Description: Ecommerce Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

/* eslint-disable */
export default {
    cartItems: [
        { "name": "wSpy Pro", "description": "1 Mês", "price": 99.99, "quantity": 1 }
    ],
    wishList: []
}
/* eslint-enable */
